import {
    DatiqGraphAxisType,
    DatiqGraphRange,
    DatiqGraphSeriesType,
} from './datiq-graph.enum';
import {
    IDatiqGraph,
    IDatiqGraphAxis,
    IDatiqGraphGrid,
    IDatiqGraphRanged,
    IDatiqGraphSeries,
    IDatiqGraphSeriesData,
    IDatiqGraphSeriesDataTooltipTable,
    IDatiqGraphSeriesDataTooltipTableHeader,
    IDatiqGraphSeriesDataTooltipTableRow,
} from './datiq-graph.interface';
import {
    DATIQ_DEFAULT_ARRAY,
    DATIQ_DEFAULT_BOOLEAN,
    DATIQ_DEFAULT_DATE_RANGE,
    DATIQ_DEFAULT_EMPTY_LABEL,
    DATIQ_DEFAULT_NUMBER,
} from '@dat/datiq-core/models';
import { datGrey } from '@dat/datiq-components-pkg/utils';

export const DATIQ_GRAPH_ID_SUFFIX = 'datiq-graph';
export const DATIQ_GRAPH_ID_SEPARATOR = '__';
export const DATIQ_GRAPH_SERIES_ID_SUFFIX = 'datiq-graph-series';

export const DATIQ_GRAPH_ID: (parts: string[]) => string = (parts: string[]) =>
    parts
        .concat(DATIQ_GRAPH_ID_SUFFIX)
        .reduce((currentId: string, part: string, index: number) =>
            index === 0
                ? part
                : `${currentId}${DATIQ_GRAPH_ID_SEPARATOR}${part}`
        );

export const DATIQ_GRAPH_SERIES_ID: (parts: string[]) => string = (
    parts: string[]
) =>
    parts
        .concat(DATIQ_GRAPH_SERIES_ID_SUFFIX)
        .reduce((currentId: string, part: string, index: number) =>
            index === 0
                ? part
                : `${currentId}${DATIQ_GRAPH_ID_SEPARATOR}${part}`
        );

export const emptyDatiqGraphRangeNumber: DatiqGraphRange = {
    start: DATIQ_DEFAULT_NUMBER,
    end: DATIQ_DEFAULT_NUMBER,
};

export const emptyDatiqGraphAxisY: IDatiqGraphAxis = {
    type: DatiqGraphAxisType.Number,
};

export const emptyDatiqGraph: IDatiqGraph = {
    id: DATIQ_GRAPH_ID(DATIQ_DEFAULT_ARRAY as string[]),
    series: DATIQ_DEFAULT_ARRAY as IDatiqGraphSeries[],
    yAxes: DATIQ_DEFAULT_ARRAY as IDatiqGraphAxis[],
    xAxes: DATIQ_DEFAULT_ARRAY as IDatiqGraphAxis[],
    hasData: DATIQ_DEFAULT_BOOLEAN,
};

export const emptyDatiqGraphRangeDate: DatiqGraphRange = {
    ...DATIQ_DEFAULT_DATE_RANGE,
};

export const emptyDatiqGraphAxisX: IDatiqGraphAxis = {
    type: DatiqGraphAxisType.Date,
};

export const emptyDatiqGraphSeries: IDatiqGraphSeries = {
    id: DATIQ_GRAPH_SERIES_ID(['empty']),
    type: DatiqGraphSeriesType.Line,
    data: [...(DATIQ_DEFAULT_ARRAY as IDatiqGraphSeriesData[])],
};

export const emptyDatiqGraphRanged: IDatiqGraphRanged = {
    openValueY: 'y',
    valueY: 'yClose',
};

export const emptyDatiqGraphSeriesRange: IDatiqGraphSeries = {
    ...emptyDatiqGraphSeries,
    ranged: { ...emptyDatiqGraphRanged },
};

export const emptyDatiqGraphSeriesDataTooltipTable: IDatiqGraphSeriesDataTooltipTable =
    {
        title: DATIQ_DEFAULT_EMPTY_LABEL,
        headers:
            DATIQ_DEFAULT_ARRAY as IDatiqGraphSeriesDataTooltipTableHeader[],
        rows: DATIQ_DEFAULT_ARRAY as IDatiqGraphSeriesDataTooltipTableRow[],
    };
export const emptyDatiqGraphGridY: Partial<IDatiqGraphGrid> = {
    strokeDasharray: [3, 4],
    strokeWidth: 1,
    strokeOpacity: 1,
    stroke: datGrey['100'],
};
export const emptyDatiqGraphGridX: Partial<IDatiqGraphGrid> = {
    strokeOpacity: 0,
};
